module.exports = __webpack_public_path__ + "static/img/6.316188fb.png";